import { VideoReviews as VideoReviewsProps } from 'types/studio/studio';
import { UnifiedButton, UnifiedButtonType } from 'shared/studio/UnifiedButton';

type VideoReviewsRatingProps = {
  className?: string;
  sectionType: string;
} & Pick<VideoReviewsProps, 'unifiedButton'>;

export const VideoReviewsButton = (props: VideoReviewsRatingProps) => {
  const { unifiedButton, sectionType, className } = props;

  return (
    <>
      {unifiedButton && unifiedButton?.switchButton !== 'noButton' && (
        <UnifiedButton
          // TOOD: remove type casting
          // buttonv2 in unifiedbutton schema shouldn't have tertiary variant
          unifiedButton={unifiedButton as UnifiedButtonType}
          sectionType={sectionType}
          className={className}
          size="medium"
          theme="new"
        />
      )}
    </>
  );
};
